jQuery(function ($) {
  setTimeout(function () {
    var installationVal = $('.product-options-label[data-attr="Installation Type"] .flase-adpter').text().trim();
    if (installationVal) {
      $('.installation input').val(installationVal).attr('ymq-option-price', 0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
    }
    var cabinetVal = $('.product-options-label[data-attr="Cabinet Material"] .flase-adpter').text().trim();
    if (cabinetVal) {
      $('.cabinet-material input').val(cabinetVal).attr('ymq-option-price', 0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
    }
  }, 500); 
});

$( function() {
var updateSizeAndPrice = function() {
  var widthSize = $(".widthSize-inch");
  var heightSize = $(".heightSize-inch");
  var width = parseInt(widthSize.text());
  var height = parseInt(heightSize.text());
  var size = 'width:' + widthSize.attr("size-data") + ', height:' + heightSize.attr("size-data");
  var price = 0;

  if (width + height != 52) {
    const cost_coef1 = {
      con: -61.43767931,
      x: 2.205711465,
      y: 1.986026393,
      s: -0.000816521,
      c: 1.415596439
    };
    const cost_coef2 = {
      con: 299.883986,
      x: -2.538633704,
      y: -5.360809299,
      s: 0.123439401,
      c: 3.117467307
    };
    const cost_est = function(x, y) {
      const s = x * y;
      const c = x + y + Math.min(x, y);
      let cost;
      if (s < 1900) {
        cost = cost_coef1.con + cost_coef1.x * x + cost_coef1.y * y +
          cost_coef1.s * s + cost_coef1.c * c;
      } else {
        cost = cost_coef2.con + cost_coef2.x * x + cost_coef2.y * y +
          cost_coef2.s * s + cost_coef2.c * c;
      }
      return cost;
    };
    const mult_coef1 = {
      con: 6.856568154,
      x: 0.030422952,
      y: 0.042881326,
      s: 0.000690259,
      c: -0.067146046
    };
    const mult_est1 = function(x, y) {
      const s = x * y;
      const c = x + y + Math.min(x, y);
      const mult = mult_coef1.con + mult_coef1.x * x + mult_coef1.y * y +
        mult_coef1.s * s + mult_coef1.c * c;
      return mult;
    };
    const mult_est3 = function(x, y) {
      const mult = (x + 30) / (y + 30) + 2;
      return mult;
    };
    const mult = function(x, y) {
      const mult1 = mult_est1(x, y);
      const mult3 = mult_est3(x, y);
      const mult = Math.max(mult1, mult3);
      return mult;
    };
    const price_est = function(x, y) {
      return cost_est(x, y) * mult(x, y);
    };

    var price = price_est(width, height);
    price = Math.floor(price) - 628;
  $('.ymq_size_money input').val( size ).attr('ymq-option-price',Number(price)).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
  }else{
  let price = 0;   
  $('.ymq_size_money input').val( size ).attr('ymq-option-price',Number(price)).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });   
  }  
     if(width >= 20 && height >= 20  ){
              $(".custom-option-select-clock").removeClass("no-drop");
           }else{
             $(".custom-option-select-clock").addClass("no-drop");
         $(".product-options-label-clock").children("span").empty().text("Select");
           $('.clock input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
           }


  
if (width < 20 || height < 20) {
    $(".custom-option-select-mirror").addClass("no-drop");
     $(".product-options-label-mirror").children("span").empty().text("Select");
     $('.makeup-mirror input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     }else if(width >= 20 && width <= 48 ){  
  
$('.custom-option-select-mirror .product-options-single').each(function() {
  var dataVal = $(this).attr('data-val');
  if (dataVal.includes('170')) {
    $(this).hide();
  } else {
    $(this).show();
  }
});
var spanElement = $('.product-options-label-mirror span');
var spanText = spanElement.text();
if (spanText.includes('170')) {
  spanText = spanText.replace('170', '150');
    spanText = spanText.replace('45', '35');
  spanElement.text(spanText);
$('.makeup-mirror input').val(spanText).attr('ymq-option-price','35').each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else if(spanText.includes('150')){
  
}else{
  spanElement.text('Select');
$('.makeup-mirror input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}
$(".custom-option-select-mirror").removeClass("no-drop");
       
} else  if(width > 48 ){
  
$('.custom-option-select-mirror .product-options-single').each(function() {
  var dataVal = $(this).attr('data-val');
  if (dataVal.includes('150')) {
    $(this).hide();
  } else {
    $(this).show();
  }
});
var spanElement = $('.product-options-label-mirror span');
var spanText = spanElement.text();
if (spanText.includes('150')) {
  spanText = spanText.replace('150', '170');
    spanText = spanText.replace('35', '45');
  spanElement.text(spanText);
$('.makeup-mirror input').val(spanText).attr('ymq-option-price','45').each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else if(spanText.includes('170')){
  
}else{
  spanElement.text('Select');
$('.makeup-mirror input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}
$(".custom-option-select-mirror").removeClass("no-drop");

}


  
          if(width >= 20 && height >= 20  ){
                $(".custom-option-select-wifi").removeClass("no-drop")
                $(".custom-option-select-bluetooth").removeClass("no-drop");
                $(".custom-option-select-demister").removeClass("no-drop")
             }else{
                     $(".custom-option-select-wifi").addClass("no-drop");
                     $(".custom-option-select-bluetooth").addClass("no-drop");
                     $(".custom-option-select-demister").addClass("no-drop");        
                     $(".product-options-label-wifi").children("span").empty().text("Select");
                     $(".product-options-label-bluetooth").children("span").empty().text("Select");
                     $(".product-options-label-demister").children("span").empty().text("Select");
                     $('.clock-wifi input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
                     $('.bluetooth-speaker input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
                     $('.demister input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });  
               }

                  if(width >=80 || height >=80 ){
                   $(".product-options-single-rush").removeClass("product-options-single").addClass("product-options-single-rush-no")
                  $(".product-options-label-rush").children("span").empty().text("Select"); 
                  $(".options-single-rush-p").css("color","#b9083a")
           $('.delivery input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
                }else{
             $(".product-options-single-rush").addClass("product-options-single").removeClass("product-options-single-rush-no") 
             $(".options-single-rush-p").css("color","#a9a9a9")
                }
// Keep the edge selector openable. The purchase panel disables only the
// Beveled Edge row when the selected dimensions exceed its product limit.
$(".custom-option-select-edge").removeClass("no-drop");
};

$(".product-options-single-size-width>li, .product-options-single-size-height>li").on('click', function(){
var size = $(this).text();
$(this).parent().siblings().children("span").empty().text(size);
$(this).parent().siblings().children("span").attr("size-data", size);
$(".product-options-single-size").removeClass("active");
updateSizeAndPrice();
})

// The cabinet starts at 26 × 26 inches; synchronize the purchase property on load.
updateSizeAndPrice();


  $(".product-options-label").on('click', function(){
    $(this).children(".icon--chevron").toggleClass("ico-rotate")
    $(this).siblings().toggleClass("active");
     $(this).parent().parent().siblings().children().children(".product-options-content").removeClass("active");
    
  })

  $(".product-options-single").on('click', function(){
  $(".product-options-content").removeClass("active");
 $(".icon--chevron").removeClass("ico-rotate");
 var val = $(this).attr("data-val");
var pricei = $(this).attr("data-price");  
var vall = val + '\xa0' +'\xa0' + pricei;
  if (typeof(pricei)=="undefined" ){
$(this).parent().siblings().children("span").empty().text(val);
  }else{
 $(this).parent().siblings().children("span").empty().text(vall);   
  }  
var attr = $(this).parent().siblings().attr("data-attr");   
 switch(attr){
  case ("Mirror Edge Craftsmanship"):
   if(String(val).toLowerCase() == 'none'){ 
 $('.mirror-edge input').val(val).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
   }else{
 $('.mirror-edge input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
   }
 break;

     
  case ("Color Temperature"):
   var colorPrice = typeof pricei === 'string' ? Number(pricei.replace(/[^0-9\.-]+/g,"")) : 0;
   $('.color-temperature input').val(val).attr('ymq-option-price', colorPrice).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });

 break;
     
  case ("Illumination Switch"):
     if( val == "Touch Switch"){
 $('.Illumination-switch input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     } else{    
 $('.Illumination-switch input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     }
 break;
     
   case ("Adapter"):
 $('.adapter input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
 break;



  case ("Cabinet Material"):
 $('.cabinet-material input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
if (val == "Wooden") {
  $('.product-options-single[data-val="Recessed"]').hide();
 $('.installation input').val('Installation with Clips').attr('ymq-option-price', 0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
  
  const falseAdapterElement = $('.product-options-label[data-attr="Installation Type"] .flase-adpter');
  if (falseAdapterElement.length) {
    falseAdapterElement.text("Installation with Clips");
  }
} else {
  $('.product-options-single[data-val="Recessed"]').css('display', 'flex');
}
 break;


        case ("Installation Type"):
 $('.installation input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
    if( val == "Recessed"){
 $('.bluetooth-speaker input').val("").attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
$(".product-options-label-bluetooth").children("span").empty().text("Select");
  $('.product-options-single[data-val="Bluetooth Speaker"]').css('display', 'none');
}else{
     $('.product-options-single[data-val="Bluetooth Speaker"]').css('display', 'flex'); 
}

 break;
     
   case ("Backlight"):
     if(String(val).toLowerCase() == "none"){
 $('.backlight input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     } else{
 $('.backlight input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
     }
 break;

        case ("Frame"):
     if ($(this).data('price')) {
    $('.frame input').val(val).attr('ymq-option-price', Number(pricei.replace(/[^0-9\.-]+/g, ""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
} else {
    $('.frame input').val(val).attr('ymq-option-price', 0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}
 break;

  case ("Demister"):
if(String(val).toLowerCase() == "none"){
 $('.demister input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else{
  $('.demister input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); }); 
}
 break;

  case ("Makeup Mirror"):
if(String(val).toLowerCase() == "none"){
   $('.makeup-mirror input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else{
   $('.makeup-mirror input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}


 break;


  case ("Bluetooth Speaker"):
     if(String(val).toLowerCase() == "none"){
 $('.bluetooth-speaker input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else{
 $('.bluetooth-speaker input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
  }
 break;

  case ("Clock / Wi-Fi Weather Station"):
if(String(val).toLowerCase() == "none"){
   $('.clock-wifi input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else {
   $('.clock-wifi input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}   
 break;

  case ("Clock"):
if(String(val).toLowerCase() == "none"){
   $('.clock input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}else {
   $('.clock input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}   
 break;

 case ("Delivery Time"):
var Widthinch =  parseInt($(".widthSize-inch").text());
if( val == "Free Standard Delivery (8–10 Weeks)"){
 $('.delivery input').val( val ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });

}else if ( val == "Express Shipping (5–6 Weeks)") { 
if( Widthinch >= 80 ){
   $(this).parent().siblings().children("span").empty().text("Free Standard Delivery (8–10 Weeks)"); 
 $('.delivery input').val( "Free Standard Delivery (8–10 Weeks)" ).attr('ymq-option-price',0).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); }); 
}else{
 $('.delivery input').val( val ).attr('ymq-option-price',Number(pricei.replace(/[^0-9\.-]+/g,""))).each(function() { this.dispatchEvent(new Event('change', { bubbles: true })); });
}

  }
 break;       
  }      
  })     

      $(".product-options-label-delivery>.product-options-single").on('click', function(){
$(this).parent().siblings().removeClass("border-cuistom").parent().siblings().removeClass("font-cuistom")
var val = $(this).attr("data-val");
if ( val == "Free Standard Delivery (8–10 Weeks)" || val == "Express Shipping (5–6 Weeks)" ){

   $(".flase-add-to-cart").addClass("hidden")
$("#AddToCart").removeClass("hidden")
    $(".add-flase-p").addClass("hidden"); 

}else{
$(".flase-add-to-cart").removeClass("hidden")
$("#AddToCart").addClass("hidden")
 $(".add-flase-p").removeClass("hidden"); 

  
}
  }) 

   var ico = `<div class="option-label-i-ico">More information</div>`;
 $(".option-label-i").hover(function(){
           $(this).append(ico);
    }, function() {  
  $(".option-label-i-ico").remove();
   }) 

   $(".option-label-i").on('click', function(){
     $(this).siblings(".option-label-i-content").addClass("active");
         $(".option-label-i-content").hover(function(){
    }, function() {  
     $(this).removeClass("active")
   }) 
  }) 
   $(".option-label-i-content span").on('click', function(){
     $(".option-label-i-content").removeClass("active")
  }) 

  $(".flase-add-to-cart").on('click', function(){
$(".add-flase-p").removeClass("hidden");
  var del = $(".false-deliviry").text();   
    if ( del== "Select" ){
  $(".false-deliviry").parent().addClass("border-cuistom").parent().siblings().addClass("font-cuistom")
}
 })

})
